import { render } from "./SearchItem.vue?vue&type=template&id=5ec29c67&scoped=true"
import script from "./SearchItem.vue?vue&type=script&lang=js"
export * from "./SearchItem.vue?vue&type=script&lang=js"

import "./SearchItem.vue?vue&type=style&index=0&id=5ec29c67&scoped=true&lang=scss"

import exportComponent from "/Users/michellmonroy/Documents/dev-glider/catalogue-api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec29c67"]])

export default __exports__